import { createSection } from '../createSection'

/**
 * Box Inner section
 *
 * @public
 */
export const boxInner = createSection('inner', 'span')
